import { motion } from 'framer-motion';
import { Cloud, Mail } from 'lucide-react';
import { DATA_FR } from '../data/fr';
import { LABELS } from '../data/labels';

export const Header = ({
  data,
  labels
}: {
  data: typeof DATA_FR,
  labels: typeof LABELS['fr']
}) => (
  <motion.div
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    className="mb-8"
  >
    <div className="bg-gradient-to-br from-primary-container via-surface-container to-tertiary-container/30 rounded-[32px] p-8 text-on-surface shadow-elevation-1">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
        <div>
          <h1 className="text-4xl md:text-5xl font-normal text-on-surface mb-2 tracking-tight">
            {data.personal.name}
          </h1>
          <p className="text-lg md:text-xl text-on-surface-variant flex items-center gap-2 mb-4">
            <Cloud className="w-5 h-5 text-primary" />
            {data.personal.role}
          </p>
          <p className="text-base text-on-surface-variant max-w-2xl leading-relaxed">
            {data.personal.summary}
          </p>
        </div>
        <div className="flex flex-col items-end gap-3 mt-4 md:mt-0">
          <a href={`mailto:${data.personal.email}`} className="btn-primary shadow-elevation-2 hover:shadow-elevation-3">
            <Mail className="w-4 h-4" />
            {labels.contact}
          </a>
        </div>
      </div>
    </div>
  </motion.div>
);
